import { EMAIL_API } from 'modules/email/api/email-api'
import { EmailTemplateItemInterface } from 'modules/email/types/email-template-interface'
import { useMemo } from 'react'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { DataWithPaginationInterface } from 'shared/types/pagination-interface'
import useSWR from 'swr'

export function useGetEmailTemplates() {
  const { user } = useUser()
  const { fetcher } = useFetch<
    RequestMethodsEnum.get,
    DataWithPaginationInterface<EmailTemplateItemInterface>
  >({ method: RequestMethodsEnum.get })

  const { data, mutate: mutateTemplates } = useSWR(() => user && `${EMAIL_API}/templates`, fetcher)

  const templates = useMemo(() => data?.items, [data])

  return { templates, mutateTemplates }
}
